import './DetailsGridItem.css';
import FieldNames from '../../../defaults/FieldNames.json';
import { Avatar, Chip, Link, Grid } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import {useDispatch, useSelector} from 'react-redux';
import { makeStyles } from '@mui/styles';
import {
    getConditionClassBasedOnDepartureIndex,
    getFieldDisplayValue,
    isFeaturePlannedOrActual,
    isFeaturePostFire,
} from '../../../utils/FeatureHelper';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import fieldsDefinition from '../FieldInfo.json';
import ColorConstants from '../../../defaults/ColorConstants';
import { currencyFormatWithDollar } from '../../../utils/FormatHelper';
import { formatDateForDisplay } from '../../../utils/DateHelper';

import DetailsInteragency from './DetailsInteragency';
import {setIsActual, setMode} from "../../../redux/slices/detailsSlice";

const useStyles = makeStyles(() => ({
    highlight: {
        backgroundColor: 'yellow',
    },
}));

export default function DetailsPlannedGridItem({
    field,
    plannedFeature, // TODO - Leave for now - prop is overloaded!
    isFieldHighlighted,
    setCostFundingPopoverOpen,
    setCostFundingPopoverUsePlannedActual,
    interagencySelected,
    setInteragencySelected,
    otherInteragencySelected,
    setOtherInteragencySelected,
}) {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const mode = useSelector((state) => state.details.mode);
    const isTreatment = useSelector((state) => state.details.isTreatment);

    const classes = useStyles();

    let allFields = FieldNames.featureFields;
    const costFields = FieldNames.costFields;
    const currentfieldInfo = fieldsDefinition[field];

    const percentageFormat = (num) => {
        if (num) {
            const trimmedNum = num.trim("'");
            return trimmedNum + '%';
        } else {
            return '0%';
        }
    };

    const onManageCosts = () => {
        setCostFundingPopoverOpen(true);
        setCostFundingPopoverUsePlannedActual(true);
    };

    const getReadOnlyString = (fieldName) => {
        const completeDetails = plannedFeature;
        const isPostFire = isFeaturePostFire(completeDetails?.attributes);
        if (completeDetails) {
            let finalValue = completeDetails.attributes[fieldName];
            if (fieldName && costFields?.includes(fieldName)) {
                finalValue = currencyFormatWithDollar(completeDetails.attributes[fieldName]);
            } else if (fieldName === allFields.isFunded) {
                if (completeDetails.attributes[fieldName] === FieldNames.yesNo.yes) {
                    finalValue = FieldNames.yesNo.yes;
                } else {
                    finalValue = FieldNames.yesNo.no;
                }
            } else if (fieldName === allFields.vegDeparturePercentageManual) {
                finalValue = getConditionClassBasedOnDepartureIndex(
                    completeDetails.attributes[fieldName]
                );
            } else if (
                fieldName === allFields.interagencySupport &&
                !isPostFire &&
                completeDetails?.attributes[allFields.isInteragency] === FieldNames.yesNo.yes
            ) {
                if (completeDetails?.attributes[allFields.interagencyName]) {
                    finalValue = completeDetails?.attributes[allFields.interagencyName]
                        ?.split('|')
                        ?.sort((a, b) => (a > b ? 1 : -1))
                        ?.join(', ');
                } else {
                    finalValue = '--';
                }
            } else if (fieldName === allFields.interagencySupport && isPostFire) {
                finalValue = '';
            } else if (
                fieldName === allFields.initiationDate ||
                fieldName === allFields.completionDate ||
                fieldName === allFields.localApprovalDate ||
                fieldName === allFields.agencyApprovalDate ||
                fieldName === allFields.departmentApprovalDate ||
                fieldName === allFields.regionalApprovalDate ||
                fieldName === allFields.cancelledDate ||
                fieldName === allFields.createdOnDate ||
                fieldName === allFields.lastModifiedDate
            ) {
                finalValue = completeDetails.attributes[fieldName]
                    ? formatDateForDisplay(completeDetails.attributes[fieldName])
                    : '--/--/----';
            } else if (fieldName === allFields.parentID) {
                finalValue = (
                    <Link
                        onClick={() =>
                            parentRedirect(
                                completeDetails.attributes[fieldName],
                                FieldNames.modes.read,
                                completeDetails
                            )
                        }
                    >
                        <span className='pointer'>{completeDetails.attributes[fieldName]}</span>
                    </Link>
                );
            } else if (
                fieldName === allFields.wbsID &&
                completeDetails.attributes[fieldName] === 'XXXXXXXXXXXX'
            ) {
                finalValue = '--';
            } else if (fieldName === allFields.estimatedSuccessProbability) {
                finalValue = completeDetails.attributes[fieldName].replace(/'/g, '');
                finalValue = percentageFormat(finalValue);
            } else if (
                fieldName === allFields.wbsID &&
                completeDetails.attributes[fieldName] &&
                completeDetails.attributes[fieldName] !== 'XXXXXXXXXXXX'
            ) {
                if (
                    finalValue &&
                    !finalValue.includes('LF.HF') &&
                    completeDetails.attributes &&
                    completeDetails.attributes[FieldNames.featureFields.fundingAgency] &&
                    completeDetails.attributes[FieldNames.featureFields.fundingAgency].includes(
                        FieldNames.agencies.blm
                    ) &&
                    completeDetails.attributes[FieldNames.featureFields.wbsID].length === 4
                ) {
                    finalValue = 'LF.HF.' + completeDetails.attributes[fieldName] + '0000';
                } else {
                    finalValue = completeDetails.attributes[fieldName];
                }
            } else if (currentfieldInfo?.domain && currentfieldInfo?.domain.codedValues) {
                const codes = currentfieldInfo?.domain.codedValues;
                codes.forEach((element) => {
                    if (plannedFeature?.attributes[fieldName] === element.code) {
                        finalValue = element.name;
                    }
                });
            } else if (fieldName === 'ManageCosts') {
                finalValue = (
                    <div className='list-item-incident-name-vir'>
                        <Chip
                            className='required-field-status-chip'
                            onClick={() => onManageCosts()}
                            avatar={
                                <Avatar
                                    style={{
                                        fontSize: '12px',
                                        width: '22px',
                                        height: '22px',
                                        backgroundColor: ColorConstants.AvatarColor,
                                        color: ColorConstants.WhiteAlien,
                                    }}
                                >
                                    <AttachMoneyIcon />
                                </Avatar>
                            }
                            label={
                                <span style={{ fontSize: '12px', lineHeight: '21px' }}>
                                    View Estimated Costs
                                </span>
                            }
                        />
                    </div>
                );
            } else if (
                fieldName === allFields.fundingDepartment ||
                fieldName === allFields.fundingAgency ||
                fieldName === allFields.fundingRegion ||
                fieldName === allFields.fundingUnit ||
                fieldName === allFields.fundingSubUnit ||
                fieldName === allFields.fundingTribe ||
                fieldName === allFields.fundingSource ||
                fieldName === allFields.fundingSourceProgram ||
                fieldName === allFields.fundingSourceCategory ||
                fieldName === allFields.fundingSourceSubCategory ||
                fieldName === allFields.fundingUnitType
            ) {
                const tempVal = getFieldDisplayValue(
                    completeDetails.attributes[fieldName],
                    fieldName,
                    allFields
                );
                finalValue = tempVal;
            } else {
                finalValue = completeDetails.attributes[fieldName];
            }
            return finalValue;
        }
    };

    const parentRedirect = (objectId, modeState, details) => {
        const isPostFire = isFeaturePostFire(details);
        const isActual = isFeaturePlannedOrActual(false, details, FieldNames.featureFields);
        const entityStringValue = isPostFire ? 'pf' : 'f';
        if (!isTreatment) {
            navigate(`/${entityStringValue}/activities/${objectId}`,
            );
        } else {
            navigate(`/${entityStringValue}/treatments/${objectId}`,
            );
        }
        dispatch(setIsActual(isActual));
        dispatch(setMode(modeState));
    };

    const getDisplay = () => {
        if (
            plannedFeature?.attributes[field] ||
            (field === FieldNames.featureFields.interagencySupport &&
                mode === FieldNames.modes.read)
        ) {
            return getReadOnlyString(field);
        } else if (field === 'ManageCosts') {
            return getReadOnlyString(field);
        } else if (
            field === FieldNames.featureFields.interagencySupport &&
            mode === FieldNames.modes.edit
        ) {
            if (
                plannedFeature?.attributes[FieldNames.featureFields.isInteragency] ===
                FieldNames.yesNo.yes
            ) {
                return (
                    <DetailsInteragency
                        detail={plannedFeature}
                        fieldInfo={currentfieldInfo}
                        field={field}
                        onFieldChange={null}
                        allFields={FieldNames.featureFields}
                        interagencySelected={interagencySelected}
                        setInteragencySelected={setInteragencySelected}
                        otherInteragencySelected={otherInteragencySelected}
                        setOtherInteragencySelected={setOtherInteragencySelected}
                        itemsToDelete={null}
                        setItemsToDelete={null}
                        isDisabled={true}
                    />
                );
            } else {
                return '';
            }
        } else {
            return '--';
        }
    };

    return (
        <Grid
            item
            size={12}
            container
            direction='column'
            className='grid-item'
            style={{ alignItems: 'left', paddingRight: '5px' }}
        >
            <Grid
                item
                size={12}
                style={{
                    padding: '5px 2px 5px 2px',
                    whiteSpace: 'pre-wrap',
                    wordWrap: 'break-word',
                    maxWidth: '100%',
                }}
                className={isFieldHighlighted ? classes.highlight : ''}
            >
                {getDisplay()}
            </Grid>
        </Grid>
    );
}
